import React from 'react';
import ReactDOM from 'react-dom/client';
// Inter is bundled, not fetched from Google: offline or on a slow connection iOS fell back to the system font.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import { installAppLog, quickReloadRoute } from './lib/appLog';

function syncThemeColorMeta() {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return;
  const accent900 = getComputedStyle(document.documentElement)
    .getPropertyValue('--accent-900')
    .trim();
  if (accent900) meta.setAttribute('content', accent900);
}

syncThemeColorMeta();
// A reload right after the last session was alive (the web process replaced on an open, 2026-10-29) lands back on the
// page you were on; the router reads the URL once, so it is set before React starts. Native only: a deep link arrives
// through the app URL event, not the initial path, so nothing is lost by this.
{
  const back = quickReloadRoute();
  if (back && back !== window.location.pathname) {
    try {
      window.history.replaceState(null, '', back);
    } catch {
      /* the page still opens, on its own route */
    }
  }
}
// Before React: an error during the first render is exactly what app_logs is for.
installAppLog();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
